import React, { useContext } from 'react';
import { HSOptions } from '../../../constants/HSOptions';
import Select from '../Select';
import { FormContext } from '../Form';
import Row from '../../layout/Row';

const AutoSelectAndUpgrade = ({ isAward, ...props }) => {
    const { values, setValue } = useContext(FormContext);

    const autoSelect = [...HSOptions.washClub.autoSelect];
    const allowUpgrades = [...HSOptions.washClub.allowUpgrades];

    if (isAward) {
        autoSelect.shift();
        allowUpgrades.shift();
    }

    const autoVal = values[props.upgrades || 'allowUpgrades'];
    const YesNo = ['True', 'False'];
    const filterIt = YesNo.includes(autoVal);
    const filteredValues = autoSelect.filter(e => YesNo.includes(e.value));

    return (
        <Row wrap>
            <Select
                label='Allow Upgrades'
                name={props.upgrades || 'allowUpgrades'}
                options={allowUpgrades}
                callback={res => {
                    setValue(props.select || 'autoSelect', res);
                }}
                required
            />
            <Select
                label='Auto Select'
                name={props.select || 'autoSelect'}
                options={filterIt ? filteredValues : autoSelect.filter(e => e.value === autoVal)}
                required
            />
        </Row>
    )
}

export default AutoSelectAndUpgrade;
